

export const index = 6;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/docs/api-reference/overview/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/6.Ncb3jcsg.js","_app/immutable/chunks/mtF927Wn.js","_app/immutable/chunks/C8t-7i39.js","_app/immutable/chunks/IHki7fMi.js","_app/immutable/chunks/DW5DwYHW.js"];
export const stylesheets = ["_app/immutable/assets/6.CfUIQUlz.css"];
export const fonts = [];
